function dcg_UserTrack ( name , value , callback ) {
    value = value || '' ;
    callback = callback || function () { } ;

    var url = SETUP_INDEX + '?module=stats_events'  ;

    url += '&index[stats_events][action]=track' ;
    url += '&index[stats_events][skipMainTemplate]=TRUE' ;
    url += '&index[stats_events][name]=' + name ;
    url += '&index[stats_events][value]=' + value ;
    url += '&token=' + CSRF_TOKEN ;
    url += '&ajax=TRUE' ;

    return $.ajax ( {
                url : url,
                type: 'GET',
                success : callback
            } ) ;
}

$( document ).on ( 'areaReady' , function ( event ) {
    $( '.track-user' , event.target ).click ( function ( e ) {    
        var element = $( this ) ;

        if ( element.is ( 'a' ) ) {
            e.preventDefault () ;  
        }
           
        var name = $( this ).attr ( 'data-track-name' ) ;

        if ( typeof name == typeof undefined || name == false ) {
            return true ;
        }

        var value = $( this ).attr ( 'data-track-value' ) ;  
        
        if ( typeof value == typeof undefined || value == false ) {
            value = '' ;
        }
        
        dcg_UserTrack ( name , value , function () {
            if ( element.is ( 'a' ) ) {
                document.location.href = element.attr ( 'href' ) ;      
            }
        } ) ;
    } );
    
    $( '.site-logo' , event.target ).click (
        function () {
            dcg_UserTrack ( 'logo_click' ) ;
        }
    ) ;
} ) ;
